var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-position-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _vm.currentUser && _vm.currentUserRecord.length > 0
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              attrs: {
                "modal-append-to-body": "",
                "append-to-body": "",
                top: _vm.dialogTopMargin,
                title: "【" + _vm.currentUser.name + "】 旅客回傳紀錄",
                visible: _vm.dialogUserVisible,
                width: "40%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogUserVisible = $event
                },
              },
            },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.listLoading,
                            expression: "listLoading",
                          },
                        ],
                        attrs: {
                          size: "mini",
                          data: _vm.currentUserRecord,
                          border: "",
                          fit: "",
                          "highlight-current-row": "",
                          height: "500px",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "項次",
                            width: "60",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.$index + 1)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4178052834
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "日期",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.recordDate)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            266751807
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: _vm.funcName + "座標緯度",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(scope.row.lat))]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3516789727
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: _vm.funcName + "座標經度",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(scope.row.lng))]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3272137635
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "地圖",
                            width: "170",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.lat && scope.row.lng
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              icon: "el-icon-position",
                                              type: "success",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.googleMap(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("查看Google地圖")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            56349678
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogUserVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentTravelers && _vm.currentTravelers.length > 0
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title:
                  "【" +
                  _vm.currentTravelName +
                  "】 旅遊團旅客最新經緯度回傳紀錄",
                visible: _vm.dialogVisible,
                width: "70%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.listLoading,
                            expression: "listLoading",
                          },
                        ],
                        attrs: {
                          size: "mini",
                          data: _vm.currentTravelers,
                          border: "",
                          fit: "",
                          "highlight-current-row": "",
                          height: "100%",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "項次",
                            width: "60",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.$index + 1)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4178052834
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "日期",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.recordDate)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            266751807
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "userAccount",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.account)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1873639783
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "userName",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.name)),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2020036417
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: _vm.funcName + "座標緯度",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(scope.row.lat))]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3516789727
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: _vm.funcName + "座標經度",
                            width: "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(scope.row.lng))]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3272137635
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "明細",
                            width: "120",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getUserPosition(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("明細")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3729202208
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "地圖",
                            width: "170",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.lat && scope.row.lng
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              icon: "el-icon-position",
                                              type: "success",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.googleMap(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("查看Google地圖")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            56349678
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c("el-form-item"),
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.listLoading,
                      type: "success",
                      icon: "el-icon-refresh-left",
                      circle: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "日期", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.recordDate))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "團ID", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.travelID))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "團名", width: "400" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.travelName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "查看", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }